<template>
    <div id="backend_wrapper" style="padding: 64px 30px 64px 30px;" class="">
        <router-view :options="options"></router-view>
    </div>
</template>

<script>

    import BackendNavi from "../components/navi/NaviTopComponent";

    export default {
        name: "backend",
        props: {
            options: {
                type: Object,
                required: true
            }
        },
        data() {
            return {}
        },
        methods: {
            checkSetup() {
            }
        },
        beforeCreate() {

        },
        created() {
            this.oldNavi = this.options.navi;
            this.options.navi = BackendNavi;
        },
        beforeRouteLeave(req, res, next) {
            this.options.navi = this.oldNavi;
            next();
        },
        beforeMount() {
            if (this.options.user.loggedIn === false) {
                this.$router.push("/signin");
            }
        },
        mounted() {
            if(this.options.currentRoute != 'Brandings'){
      this.options.showBrandForm = false;
    }
        },
    }
</script>